import { Component } from '@angular/core';
import containerFormJson from '../../config/container-form-config.json';
import { ManageContainersComponent } from '../../../../inventory/container/manage-containers/manage-containers.component';


@Component({
  selector: 'app-edit-container',
  standalone: true,
  imports: [ManageContainersComponent],
  template: `
    <app-manage-containers 
      [formConfig]="containerFormConfig" 
      [returnPath]="returnPath">
    </app-manage-containers>
  `
})
export class ManageIGMContainerComponent {
  containerFormConfig: any;
  returnPath: string = "/manage-operations/igm-desk";

  ngOnInit(): void {
    this.containerFormConfig = containerFormJson.formControls;
  }
}